<template>
    <transition name="voice">
        <div v-show="this.curRecordTime" class="voice-wrap">
            <i class="iconfont icon-icon-1"></i>
            <div class="voice-level-wrap">
                <template v-for="(item, index) in new Array(10)">
                    <div
                        :key="index"
                        class="voice-level-item"
                        :class="{visiable: index > 10 - voiceLevel}"
                        :style="{width: `${10*(10-index)}%`}"
                    ></div>
                </template>
            </div>
            <div class="voice-time">00 : {{curRecordTime}}</div>
        </div>
    </transition>
</template>

<script>
export default {
  props: {
    curRecordTime: {
      type: [String, Number]
    },

    voiceLevel: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
.voice {
    &-wrap {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 294px;
        height: 294px;
        border-radius: 16px;
        overflow: hidden;
        background-color: rgba(17, 30, 46, 0.34);

        i {
            position: absolute;
            top: 50px;
            left: 30px;
            font-size: 120px;
            color: #fff;
        }

        .voice-level-wrap {
            position: absolute;
            top: 36px;
            right: 20px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            width: 120px;
            height: 160px;

            .voice-level-item {
                height: 4px;
                background: transparent;
                &.visiable {
                    background: #ffffff;
                }
            }
        }

        .voice-time {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 30px;
            height: 40px;
            font-size: 28px; /*px*/
            text-align: center;
            color: #ffffff;
        }
    }

    &-enter,
    &-leave-to {
        opacity: 0;
    }

    &-enter-active {
        transition: none;
    }

    &-leave-active {
        transition: opacity 0.3s;
    }

    &-enter-to {
        opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/transition/VoiceTransition.vue